// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'

import Vue from 'vue'
import ElementUI from 'element-ui';
Vue.use(ElementUI);
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
// import axios
import axios from "axios"
Vue.prototype.$ajax = axios

/*import 'element-ui/lib/theme-default/index.css'
import {Input,
        Col,
        Menu,
        Submenu,
        MenuItem,
        MenuItemGroup,
        Autocomplete,
        DatePicker,
        Select,
        Option,
        Button,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Tree,
        Form,
        FormItem,
        Switch,
        Pagination,
        Tabs,
        TabPane,
        Cascader,
        Upload,
        Message,
        MessageBox,
        Table
        } from 'element-ui'
var useObj= {
  Input,
  Upload,
  Col,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Autocomplete,
  DatePicker,
  Select,
  Option,
  Button,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Tree,
  Form,
  FormItem,
  Switch,
  Pagination,
  Tabs,
  TabPane,
  Cascader,
  Table
};
for(var prop in useObj){
  Vue.use( useObj[prop] )
}*/

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
//引入全局方法
import globalMethod from './assets/javascripts/vue-public.js'
for( var prop in globalMethod ){
  Vue.use( globalMethod[prop] );
}

// Vue.component(MessageBox);
// Vue.component(Message);
// Vue.prototype.$msgbox = MessageBox;
// Vue.prototype.$alert = MessageBox.alert;
// Vue.prototype.$confirm = MessageBox.confirm;
// Vue.prototype.$prompt = MessageBox.prompt;
// Vue.prototype.$message = Message;



import './assets/javascripts/url-public'
//import es6-promise
import promise from 'es6-promise';
promise.polyfill();

// 引入全部echarts
/*import echarts from 'echarts'*/

// 按需引入引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/toolbox');

Vue.prototype.$echarts = echarts



//import VueLazyload
import VueLazyload from 'vue-lazyload'//懒加载插件https://github.com/hilongjw/vue-lazyload
Vue.use(VueLazyload,{
  loading: "src/assets/images/app.png"
});

//import APP
import App from './App'

//import MAIN.less(这里可以放置一些固有样式,比如样式重置)
import "./assets/less/main.less"

import store from "./assets/vuex/store.js"

Vue.config.productionTip = false

import router from "./assets/routers/index.js"


/* eslint-disable no-new */
//选择第一个
Vue.filter("checkFirst",function( originalData ){
  for( var i=0;i<originalData.length;i++ ){
    if( originalData[i].checkbox ){
      return originalData[i];
    }
  }
});
//标准时间转换成时间戳 时间格式:'yyyy-MM-dd h:m:s'
Vue.filter("cus_time_stamp",function(originalData){
  var transData = new Date(originalData);  // 将指定日期转换为标准日期格式。Fri Dec 08 2017 20:05:30 GMT+0800 (中国标准时间)
  return transData.getTime();// 将转换后的标准日期转换为时间戳。
});

//格式化具体时间,格式化后样式为：'yyyy-MM-dd h:m:s'
Vue.filter("format_time",function( originalData ){
  var date = new Date( Number( originalData ) );
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
});
//elementUI的时间空间返回的值:2018-04-07T16:00:00.000Z,需要将其处理成2018-04-07 00:00:00


new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})




// WEBPACK FOOTER //
// ./src/main.js